import PalletList from "./palletList";

export default PalletList;
